// copy or rename this file to routingConfig.js
export default {
  hereApiKey: 'x9SeCvwikNOtxoPoDbhI8qhRSWP1Gxmz_op6V7ovguE'
}




// WEBPACK FOOTER //
// ./src/components/routing/routingConfig.js